import axios from "axios"
import { BASE_URL, ORIGEN, siteUrl, TIPO_USR, URL_CU , API_AUTH } from "./constants"

export const basePost = (data) => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    let resp = ""

    /* ejemplo uso post, el put, patch y delete se hacen igual al post */
    axios
        .post(BASE_URL + '/endpoint', data)
        .then(res => { resp = res })
        .catch(err => {
            console.log(err)
            resp = err
        })

    return resp

}

/* ejemplo uso get */
export const baseGet = () => {
    let resp = ""

    axios
        .get(BASE_URL + '/endPoint')
        .then(res => { resp = res })
        .catch(err => {
            console.log(err)
            resp = err
        })

    return resp
}

export const getDatosCiudadanoPorRut = async (rut) => {

    let resp = ""

    resp = await axios
        .get(BASE_URL + '/api/v1/ciudadano?run=' + rut)

    return resp

}



export const getIsapres = async () => {
    var config = {
      method: 'get',
      url: BASE_URL + '/api/v1/isapre?skip=0&limit=100',
      headers: {
        Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
      },
    };
    
    return await axios(config);
  };


export const getGenero = async () => {
    var config = {
      method: 'get',
      url: BASE_URL + '/api/v1/genero?skip=0&limit=100',
      headers: {
        Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
      },
    };
    
    return await axios(config);
  };



export const getMediadores = async () => {
  var config = {
    method: 'get',
    url: BASE_URL + '/api/v1/mediador?skip=0&limit=100',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };
  
  return await axios(config);
};

export const getSexo = async () => {
    var config = {
      method: 'get',
      url: BASE_URL + '/api/v1/sexo?skip=0&limit=100',
      headers: {
        Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
      },
    };
    
    return await axios(config);
  };


export const getPais = async () => {
    let resp = ""

    await axios
        .get(BASE_URL + '/api/v1/pais')
        .then(res => {
            resp = res
        })
        .catch(err => {
          
            resp = err
        })

    return resp
}


export const getRegion = async () => {
    var config = {
      method: 'get',
      url: BASE_URL + '/api/v1/region?skip=0&limit=100',
      headers: {
        Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
      },
    };
    
    return await axios(config);
  };

/*export const getComuna = async (idCiudad) => {

    let resp = ""

    await axios
        .get(BASE_URL + '/api/v1/provi/' + idCiudad)
        .then(res => {
            resp = res
        })
        .catch(err => {
            console.log(err)
            resp = err
        })


   
    return resp

}
*/
export const getComuna = async (idCiudad) => {
    var config = {
      method: 'get',
      url: BASE_URL + '/api/v1/provi/' +idCiudad,
      headers: {
        Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
      },
    };
    
    return await axios(config);
  };





export const getRegionComuna = async (idRegion) => {
    var config = {
      method: 'get',
      url: BASE_URL + '/api/v1/regcom/' +idRegion,
      headers: {
        Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
      },
    };
    
    return await axios(config);
  };





export const postFormulario = async (data) => {

 
    let resp = ""

    /* ejemplo uso post, el put, patch y delete se hacen igual al post */
    await axios
        .post(BASE_URL + '/api/v1/ingresotramite', data)
        .then(res => {
            resp = res.data
        })
        .catch(err => {
            console.log(err)
            resp = err
        })

    return resp

}

export const getLoginCu = async () => {
    let resp = await axios.get(URL_CU)    
    return resp

}

export const checkstate = async (body) => {
    let resp = await axios.post(API_AUTH +'checkstate/'+ORIGEN+TIPO_USR,body)
    return resp
}

export const logoutClaveUnica = async () => {
    return window.location.href = "https://accounts.claveunica.gob.cl/api/v1/accounts/app/logout?redirect=" + siteUrl;
};


export const postLoginSerie = async (body) => {
    let resp = await axios.post(API_AUTH + 'login_rcivil/', body)
  
    return resp

}
